import Insights from './Insights';
import * as Constants from './constants';

export const DATE_RANGES = Constants.DATE_RANGES;

export default Insights;
